import { observable, action } from 'mobx';
import { Contracts } from 'api';

class ContractsStore {
  @observable.ref contracts = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getContracts(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Contracts.getContracts(anketId);
      this.contracts = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const contractsStore = new ContractsStore();

export default contractsStore;
